import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import LevelSelectView from "@/views/LevelSelectView.vue";
import WorkshopChallengeSelectView from "@/views/WorkshopChallengeSelectView.vue";
import SettingsView from "@/views/SettingsView.vue";
import SkinView from "@/views/SkinView.vue";
import WorkshopView from "@/views/WorkshopView.vue";
import StarMapEditorView from "@/views/StarMapEditorView.vue";
import CustomStarMapView from "@/views/CustomStarMapView.vue";
import CustomMapCompleteView from "@/views/CustomMapCompleteView.vue";
import CustomLevelEditorView from "@/views/CustomLevelEditorView.vue";
import LevelMapSelectorView from "@/views/LevelMapSelectorView.vue";
import MapManagerView from "@/views/MapManagerView.vue";
import SharedMapView from "@/views/SharedMapView.vue";
import LeaderboardView from "@/views/LeaderboardView.vue";
import GameView from "@/views/GameView.vue";
import ModerationView from "@/views/ModerationView.vue";
import LegalView from "@/views/LegalView.vue";

/**
 * 页面路由统一在这里注册。
 * 页面只通过 route name 跳转，不把 URL 写死到各个组件里。
 */
const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/levels", name: "levels", component: LevelSelectView },
  { path: "/settings", name: "settings", component: SettingsView },
  { path: "/legal/:document(privacy|terms|community)", name: "legal", component: LegalView },
  { path: "/skins", name: "skins", component: SkinView },
  { path: "/workshop", name: "workshop", component: WorkshopView },
  { path: "/admin/moderation", name: "workshop-moderation", component: ModerationView },
  { path: "/workshop/challenge-map", name: "workshop-map-select", component: WorkshopChallengeSelectView },
  { path: "/workshop/star-map", name: "star-map-editor", component: StarMapEditorView },
  { path: "/workshop/maps", name: "map-manager", component: MapManagerView },
  { path: "/workshop/level-map", name: "level-map-selector", component: LevelMapSelectorView },
  { path: "/workshop/maps/:mapId", name: "custom-map-view", component: CustomStarMapView },
  { path: "/workshop/maps/:mapId/complete", name: "custom-map-complete", component: CustomMapCompleteView },
  { path: "/workshop/maps/:mapId/levels/:level(\\d+)/edit", name: "custom-level-editor", component: CustomLevelEditorView },
  { path: "/workshop/shared/:shareCode", name: "shared-map", component: SharedMapView },
  { path: "/leaderboard", name: "leaderboard", component: LeaderboardView },
  {
    path: "/game/:level(\\d+)",
    name: "game",
    component: GameView,
    props: route => ({ level: Number(route.params.level) })
  },
  { path: "/:pathMatch(.*)*", redirect: "/" }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 })
});

export default router;
